// Mandatory CSV columns � order matters for header validation
export const MANDATORY_COLUMNS = [
  "WholesalerAccountNumber",
  "CustomerFirstname",
  "CustomerSurname",
  "CustomerContactEmail",
  "CustomerContactNumber",
  "CustomerReference",
  "CustomerAuthReference",
  "ProductType",
  "OrderType",
  "CustomerAuthDate",
  "BandwidthProfile",
  "ContractTerm",
  "HasStaticIp",
  "RadiusUsername",
  "RadiusPassword", 
  "LocationId",
  "CpiId",
  "Port",
  "NtdId", 
  "CvcId",
  "NbnOrderId",
  "AvcId",
  "PriId",
  "FibreUpgrade"
];

// Fields that must NOT be empty or "N/A"
export const REQUIRED_FIELDS = [
  "WholesalerAccountNumber",
  "CustomerFirstname",
  "CustomerSurname",
  "CustomerContactEmail",
  "CustomerContactNumber",
  "CustomerReference",
  "CustomerAuthReference",
  "ProductType",
  "OrderType",
  "CustomerAuthDate",
  "BandwidthProfile",
  "ContractTerm",
  "LocationId",
  "CvcId",
  "NbnOrderId",
  "AvcId",
  "PriId"
];

// Valid product types
export const VALID_PRODUCT_TYPES = [
  "Fibre",
  "FTTP",
  "FTTB",
  "FTTN",
  "FTTC",
  "Fixed Wireless",
  "HFC"
];

// Valid order types
export const VALID_ORDER_TYPES = [
  "Connect",
  "Transfer",
  "Transition"
];

// Date format regex for yyyy-MM-dd
export const DATE_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
